const fiats = {
	AED: '/assets/fiats/aed-aed.svg',
	ARS: '/assets/fiats/ars-ars.svg',
	AUD: '/assets/fiats/aud-aud.svg',
	AZN: '/assets/fiats/azn-azn.svg',
	BDT: '/assets/fiats/bdt-bdt.svg',
	BGN: '/assets/fiats/bgn-bgn.svg',
	BHD: '/assets/fiats/bhd-bhd.svg',
	BOB: '/assets/fiats/bob-bob.svg',
	BRL: '/assets/fiats/brl-brl.svg',
	BWP: '/assets/fiats/bwp-bwp.svg',
	CAD: '/assets/fiats/cad-cad.svg',
	CHF: '/assets/fiats/chf-chf.svg',
	CLP: '/assets/fiats/clp-clp.svg',
	COP: '/assets/fiats/cop-cop.svg',
	CRC: '/assets/fiats/crc-crc.svg',
	CZK: '/assets/fiats/czk-czk.svg',
	DKK: '/assets/fiats/dkk-dkk.svg',
	DOP: '/assets/fiats/dop-dop.svg',
	EGP: '/assets/fiats/egp-egp.svg',
	EUR: '/assets/fiats/eur-eur.svg',
	GBP: '/assets/fiats/gbp-gbp.svg',
	HKD: '/assets/fiats/hkd-hkd.svg',
	HRK: '/assets/fiats/hrk-hrk.svg',
	HUF: '/assets/fiats/huf-huf.svg',
	IDR: '/assets/fiats/idr-idr.svg',
	ILS: '/assets/fiats/ils-ils.svg',
	INR: '/assets/fiats/inr-inr.svg',
	JPY: '/assets/fiats/jpy-jpy.svg',
	KRW: '/assets/fiats/krw-krw.svg',
	KWD: '/assets/fiats/kwd-kwd.svg',
	KZT: '/assets/fiats/kzt-kzt.svg',
	MXN: '/assets/fiats/mxn-mxn.svg',
	MYR: '/assets/fiats/myr-myr.svg',
	NGN: '/assets/fiats/ngn-ngn.svg',
	NOK: '/assets/fiats/nok-nok.svg',
	NZD: '/assets/fiats/nzd-nzd.svg',
	OMR: '/assets/fiats/omr-omr.svg',
	PEN: '/assets/fiats/pen-pen.svg',
	PHP: '/assets/fiats/php-php.svg',
	PLN: '/assets/fiats/pln-pln.svg',
	QAR: '/assets/fiats/qar-qar.svg',
	RON: '/assets/fiats/ron-ron.svg',
	RUB: '/assets/fiats/rub-rub.svg',
	SAR: '/assets/fiats/sar-sar.svg',
	SEK: '/assets/fiats/sek-sek.svg',
	SGD: '/assets/fiats/sgd-sgd.svg',
	THB: '/assets/fiats/thb-thb.svg',
	TRY: '/assets/fiats/try-try.svg',
	TWD: '/assets/fiats/twd-twd.svg',
	UAH: '/assets/fiats/uah-uah.svg',
	USD: '/assets/fiats/usd-usd.svg',
	UYU: '/assets/fiats/uyu-uyu.svg',
	VND: '/assets/fiats/vnd-vnd.svg',
	ZAR: '/assets/fiats/zar-zar.svg',
};

export default fiats;
